<template>
  <div class="row align-center documentos_tudo">
    <div class="small-12 medium-12 large-11 columns bolsaslist">
      <div class="row align-center">
        <div class="small-12 medium-12 large-10 columns all_content_avisos">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.row{
  max-width: 100%;
}

.documentos_tudo{
  margin-bottom: 70px;
}

@media (max-width: 1024px){
  .documentos_tudo{
    padding-left: 10%;
    padding-right: 10%;
  }
}

@media (max-width: 767px){
  .documentos_tudo{
    padding-left: 0;
    padding-right: 0;
  }
}

.bolsaslist{
  padding-right: 0;
  padding-left: 0;
  max-width: 1330px;
}

@media (max-width: 1350px) {
  .bolsaslist {
    padding-right: 0;
    padding-left: 0;
    max-width: 100%;
  }
}

@media (max-width: 767px){
  .bolsaslist{
    padding-left: 5%;
    padding-right: 5%;
  }
}

.row .row{
  margin-left: 0;
  margin-right: 0;
}

.bolsaslist .row .columns{
  padding-left: 0;
  padding-right: 0;
}

</style>